import SelfIntroduction from "../components/SharathSelfIntroduction";
import NonStickyNavAndFooter from "./layout/NonStickyNavAndFooter";

export default function About() {
    return (
        <NonStickyNavAndFooter>
            <SelfIntroduction />
        </NonStickyNavAndFooter>
    )
}